import Locale from "../../../locales";

export const buttonStyles = {
  actionButtonSx: {
    borderTopRightRadius: "0px",
    borderTopLeftRadius: "1rem",
    borderBottomRightRadius: "0px",
    borderBottomLeftRadius: "0px",
  },
  removeButtonSx: {
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderBottomRightRadius: "1rem",
    backgroundColor: "#e37777",
  },
  stopButtonSx: {
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderBottomRightRadius: "0px",
  },
};

export const cardBackground = {
  idle: "piece-list-item grey",
  ongoing: "piece-list-item yellow",
  completed: "piece-list-item green",
  inCompleted: "piece-list-item red",
};

export const cardText = {
  idle: Locale.t("not_yet_started"),
  ongoing: Locale.t("ongoing_piece"),
  completed: Locale.t("completed_piece"),
  inCompleted: Locale.t("discontinued_piece"),
};
